import { useAuth } from "../routers/AuthProvider";

function useGetPermission() {
  const { user } = useAuth();
  function hasAccess(action, module_name, sub_module_name) {
    if (!user?.role?.permissions) return false;
    return user?.role?.permissions.some((permission) => {
      return (
        permission.module_name == module_name &&
        permission.sub_module_name == sub_module_name &&
        permission?.[action] == 1
      );
    });
  }

  function hasModuleAccess(module, action) {
    if (!user?.role?.permissions) return false;

    return user?.role?.permissions.some((permission) => {
      return permission.module_name == module && permission?.[action] == 1;
    });
  }

  function hasSubModuleAccess(module, submodule) {
    const feature = user?.role?.permissions.find(
      (p) =>
        p.module_name.toLowerCase() == module.toLowerCase() &&
        p.sub_module_name.toLowerCase() === submodule.toLowerCase()
    );

    return feature ? true : false;
  }

  return {
    hasAccess,
    hasModuleAccess,
    hasSubModuleAccess,
  };
}

export default useGetPermission;
